<template>
  <div id="app">
    <hello-world v-if="false"/>
    <alt-view/>
    <app-footer />
  </div>
</template>

<script>
import AltView from './components/AltView.vue'
import AppFooter from './components/AppFooter.vue'
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    AppFooter,
    AltView
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
